// extracted by css-extract-rspack-plugin
export default {"cls1":"AddToListButton-cls1_H1C","cls2":"AddToListButton-cls2_5Ze AddToListButton-cls1_H1C"};